import React, {useEffect} from 'react';
import s from "./EntityForm.module.css";
import ImageToBase64Library from "../../../../Static/Base64/ImageToBase64Library";

const TaskForm = ({entity, changeData}) => {
    useEffect(() => {

    }, [entity]);
    console.log('entity', entity)
    return (
        <div className={s.wrapper}>
            {entity.id?<div>Изменение</div> : <div>Создание</div>}
            <div className={s.titleField}>Название </div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Название'}
                   value={entity.title}
                   onChange={(e)=>{
                       changeData({...entity, title:e.target.value})
                   }}/>

            <div className={s.titleField}>Описание</div>
            <textarea
                   className={s.input_box}
                   placeholder={'Описание'}
                   value={entity.description}
                   onChange={(e)=>{
                       changeData({...entity, description:e.target.value})
                   }}/>

            <div className={s.titleField}>Картинка к заданию</div>
            <ImageToBase64Library base64Image={entity.img} setBase64Image={base64=>changeData({...entity, img:base64})} />

            <div className={s.titleField}>Ключи</div>
            <table><tbody>
                {entity.codeWords.map((codeWord, i)=>(<tr>
                    <td><input type="text" value={codeWord} onChange={(e)=>{
                        entity.codeWords[i] = e.target.value.trim().toLowerCase()
                        changeData({...entity})
                    }}/></td>
                    <td>{i!==0 && <span  className={s.localBtn} onClick={()=>{   changeData({...entity, codeWords:entity.codeWords.filter((code, index)=>(index !== i))})}}>Убрать</span>}</td>
                </tr>))}
            </tbody></table>
            <div className={s.localBtn} onClick={()=>{changeData({...entity, codeWords:[...entity.codeWords, ""]})}}>Добавить</div>

            <div className={s.titleField}>Баллы за задание</div>
            <input type="number" value={entity.score??0} onChange={(e)=>{changeData({...entity, score: e.target.value})}}/>

            <div className={s.titleField}>Подсказка</div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Текст подсказки'}
                   value={entity.helpTask?.text??""}
                   onChange={(e)=>{
                       changeData({...entity, helpTask: {text:e.target.value, score: entity.helpTask?.score??0}});
                   }}/>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Сколько снять за подсказку'}
                   value={entity.helpTask?.score??0}
                   onChange={(e)=>{
                       changeData({...entity, helpTask: {text: e.target.value??0, score:entity.helpTask?.text??""}});
                   }}/>
            {entity.helpTask?"Подсказка есть": "Подсказки нет"}
            <div className={s.localBtn} onClick={()=>{changeData({...entity, helpTask:null});}}>Очистить подсказку</div>

            <div className={s.titleField}>Активно?  <input type="checkbox" checked={entity.isActive} onChange={(e)=>{changeData({...entity, isActive: e.target.checked})}} /></div>


        </div>
    );
};

export default TaskForm;